var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.routerAlive ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _vm.platformOrderMessage.show
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "drag",
                  rawName: "v-drag",
                  value: "drag",
                  expression: "'drag'"
                }
              ],
              staticClass: "order-message"
            },
            [
              _c(
                "div",
                { ref: "drag", staticClass: "close-icon" },
                [
                  _c("span", { attrs: { id: "drag" } }, [
                    _vm._v("超时未到分仓")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "light",
                        content:
                          "以下单据已出库，但超时未到分仓，请检查实物是否发出。若已发出且分仓收货，单据状态为‘已到分仓’",
                        placement: "bottom"
                      }
                    },
                    [_c("span", { staticClass: "el-icon-question" })]
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "el-icon-close",
                    on: { click: _vm.closePlatformMessage }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  { staticClass: "order", on: { click: _vm.goOrderRoute } },
                  [
                    _vm._v("\n        订   单："),
                    _c("span", [
                      _vm._v(_vm._s(_vm.platformOrderMessage.orderCount))
                    ]),
                    _vm._v("(单)\n      ")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "aftersale-order",
                    on: { click: _vm.goAfterOrderRoute }
                  },
                  [
                    _vm._v("\n        售后单："),
                    _c("span", [
                      _vm._v(_vm._s(_vm.platformOrderMessage.asOrderCount))
                    ]),
                    _vm._v("(单)\n      ")
                  ]
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("PendingOrderDialog")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 